import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop'; 
//import { ChartsModule } from 'ng2-charts';
import { NgxEchartsModule } from 'ngx-echarts';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { MainModule } from '../main/main.module';
import { RMMainComponent } from './rmmain/rmmain.component';
import { ObjectifComponent } from './objectif/objectif.component';
import { ActionComponent } from './action/action.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { CommentsComponent } from './comments/comments.component';
import { UsersListComponent } from './users-list/users-list.component';
import { TeamComponent } from './team/team.component';
import { AuditGeneratorComponent } from './audit-generator/audit-generator.component';
import { ObjectifFormComponent } from './objectif-form/objectif-form.component';
import { ObjectifResumeComponent } from './objectif-resume/objectif-resume.component';
import { ObjectifDoughnutComponent } from './objectif-doughnut/objectif-doughnut.component';
import { IndicatorComponent } from './indicator/indicator.component';
import { PreconizationComponent } from './preconization/preconization.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

/*/*
import { GSTCComponent } from "angular-gantt-schedule-timeline-calendar";
import { GanttComponent } from './gantt/gantt.component';
//*/

@NgModule({
  declarations: [
  	RMMainComponent, 
  	ObjectifComponent, 
    ActionComponent, 
    ChecklistComponent, 
    CommentsComponent, 
    TeamComponent, 
    UsersListComponent, 
    AuditGeneratorComponent, 
    ObjectifFormComponent, 
    ObjectifResumeComponent, 
    ObjectifDoughnutComponent, 
    IndicatorComponent, 
    PreconizationComponent
  ],
  imports: [
    CommonModule, FormsModule, DragDropModule,
    CustomMaterialModule, MainModule, TranslocoRootModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
  ],
  exports: [
    RMMainComponent, 
    ActionComponent, 
    ChecklistComponent, 
    CommentsComponent, 
    AuditGeneratorComponent, 
    ObjectifFormComponent, 
    ObjectifResumeComponent, 
    ObjectifDoughnutComponent, 
    IndicatorComponent, 
    PreconizationComponent
  ],
  entryComponents: [
    RMMainComponent, 
    UsersListComponent, 
    ObjectifFormComponent, 
    ObjectifDoughnutComponent, 
    IndicatorComponent, 
    PreconizationComponent]
})
export class RiskManagementModule { }
